export class Prestation {
  codeHecate: string;
  codeTennaxia: string;
  designation: string;
  lienDechet: string;
  libelleCaracteristiques: string;
  codeDR: string;
  typeDesignation: string;
  categorieAchatMosaic: string;
  id: number;
  typeCodeHecate: number;
  typeId: number;
  variante: string;
  constructor(categorieAchatMosaic: string, codeDR: string, codeHecate: string, codeTennaxia: string, designation: string, id: number, libelleCaracteristiques: string, lienDechet: string, typeCodeHecate: number, typeDesignation: string, typeId: number, variante: string) {
    this.codeHecate = codeHecate;
    this.codeTennaxia = codeTennaxia;
    this.designation = designation;
    this.lienDechet = lienDechet;
    this.libelleCaracteristiques = libelleCaracteristiques;
    this.codeDR = codeDR;
    this.typeDesignation = typeDesignation;
    this.categorieAchatMosaic = categorieAchatMosaic;
    this.id = id;
    this.typeCodeHecate = typeCodeHecate;
    this.typeId = typeId;
    this.variante = variante;
  }
}
